import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.54 4.59c.928-.791 2.34-.122 2.34 1.084v8.652c0 1.206-1.411 1.875-2.339 1.085l-2.668-2.27H4.42c-.787 0-1.42-.64-1.42-1.424V8.283C3 7.5 3.633 6.86 4.42 6.86h1.453L8.54 4.59Zm.916 1.06-.007.005-2.865 2.438a.7.7 0 0 1-.454.167H4.414l-.007.005a.025.025 0 0 0-.005.008.023.023 0 0 0-.002.01v3.434a.023.023 0 0 0 .007.018.034.034 0 0 0 .007.004l.006.001h1.71a.7.7 0 0 1 .454.167l2.864 2.438a.09.09 0 0 0 .007.005h.002l.01-.002c.008-.004.011-.008.011-.008s.002-.005.002-.014V5.674l-.001-.013s-.004-.005-.012-.009l-.01-.003h-.001Zm2.934 2.147a.7.7 0 0 1 .99 0l1.212 1.213 1.213-1.213a.7.7 0 0 1 .99.99L15.582 10l1.213 1.213a.7.7 0 1 1-.99.99l-1.213-1.213-1.213 1.213a.7.7 0 0 1-.99-.99L13.602 10 12.39 8.787a.7.7 0 0 1 0-.99Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=UnmuteIcon20.js.map